var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.type == 'action')?_c('UtilActionItem',{attrs:{"item":_vm.item}}):(_vm.item.type == 'widget')?_c('UtilWidgetItem',{attrs:{"item":_vm.item}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }